import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { APIHelperService } from './apiHelper.service';

@Injectable({ providedIn: 'root' })
export class RealPageService {

  constructor(
    private http: HttpClient,
    private apiHelper: APIHelperService
  ) {
    // no-op
  }

  getAllProspects() {
    return this.http.get<any>(this.apiHelper.fillUrl('realPageProspects', {}, {}))
      .pipe(map(data => {
        return data;
      }));
  }

  checkRealPageWorkers(id) {
    return this.http.get<any>(this.apiHelper.fillUrl('realPageWorkers', {id: id}, {}))
      .pipe(map(data => {
        return data;
      }));
  }
}
